import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { RestResponse as GenericRestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { PedirCitation } from 'app/modules/common/entities/pedir-cita.model';
import { CitationFormal } from 'app/modules/common/entities/citation-formal.model';
import { AknowledgementReceipt } from 'app/modules/common/entities/aknowledgement-receipt.model';
import moment, { Moment } from 'moment';
import { UpdateActuationModel } from 'app/modules/common/entities/update-actuation.model';
import { CitacionDefaultValues } from 'app/modules/common/types/citacion-default-values.type';
import { Actuation } from 'app/modules/common/types/actuation.type';
import { DropDownOption } from 'app/modules/common/types/dropdown-option.type';
import { DateTimeUtilsService } from 'app/modules/common/services/date-time-utils.service';

export interface CitationsMedico {
    medicoId: number;
    nombre: string;
}

type ActuationFeatureAdder = (actuation: any) => void;

const KEY_ACTION_CUT_DATA = 'actionCutData';

export type ActionCutData =
    | {
          actionId: number;
      }
    | {
          laeveId: number;
          fecha: Moment;
          hasta: Moment;
      };

@Injectable({providedIn:'root'})
export class ActuationService {
    public IsLoading: boolean;
    public Actuations: Array<any>;
    public currentEmployee = new BehaviorSubject(null);
    public CurrentEmployeeSubcription: Subscription;

    private ActuationsSubject = new BehaviorSubject(null);
    private Subscription: Subscription;
    public CurrentLeaveId: number;
    public acctuacionColumns: any[];
    constructor(
        public apiService: ApiService,
        private dateTimeUtils: DateTimeUtilsService
    ) {}

    public getActuationsByLeave(leaveId: number): Observable<RestResponse> {
        this.IsLoading = true;
        leaveId = leaveId ? leaveId : 0;
        let url = `${API.Actuaciones.getActuaciones}`;
        url = url.replace('{bajaId}', leaveId.toString());
        return this.apiService.get(url);
    }

    public PublishActuations(leaveId: number): void {
        this.getActuationsByLeave(leaveId).subscribe(
            (resp) => {
                this.CurrentLeaveId = leaveId;

                this.ActuationsSubject.next(resp.result);
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public SubcribeActuations(): void {
        this.Subscription = this.ActuationsSubject.asObservable()
            .pipe(filter((val) => val !== null))
            .subscribe(
                (res) => {
                    this.Actuations = res;
                    this.addComputedFields(this.Actuations, [
                        this.computeRegistroHint,
                    ]);
                    this.IsLoading = false;
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    public Unsubscribe(): void {
        this.Subscription.unsubscribe();
    }

    public UnsubcribeCurretEmployee(): void {
        this.CurrentEmployeeSubcription.unsubscribe();
    }

    public CreateVisit(visit: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createVisit}`;
        return this.apiService.post(url, visit);
    }

    public CreateContactoAdministrativo(
        ContactoAdministrativo: any
    ): Observable<RestResponse> {
        const url = `${API.Actuaciones.createContactoAdministrativo}`;
        return this.apiService.post(url, ContactoAdministrativo);
    }

    public CreateInformeMedico(model: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createInformeMedico}`;
        return this.apiService.post(url, model);
    }

    public CreateGestionConMutua(gestion: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createGestionConMutua}`;
        return this.apiService.post(url, gestion);
    }

    public CreateSolicitud(model: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createSolicitud}`;
        return this.apiService.post(url, model);
    }

    public CreateVisitAusente(visit: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createVisitAusente}`;
        return this.apiService.post(url, visit);
    }

    public createContactoFallido(visit: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createContactoFallido}`;
        return this.apiService.post(url, visit);
    }

    public createCommentario(action: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createComentario}`;
        return this.apiService.post(url, action);
    }

    public createSoliAlta(action: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createSoliAlta}`;
        return this.apiService.post(url, action);
    }

    public createMantenerIt(action: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.mantenerIt}`;
        return this.apiService.post(url, action);
    }

    public createOrden(action: any): Observable<RestResponse> {
        const url = `${API.Actuaciones.createOrden}`;
        return this.apiService.post(url, action);
    }

    public getActuationCount(
        leaveId: number,
        leaveDate: string
    ): Observable<RestResponse> {
        let url = `${API.Actuaciones.actuationCount}`;
        url = url
            .replace('{leaveId}', leaveId.toString())
            .replace('{leaveDate}', leaveDate);
        return this.apiService.get(url);
    }

    public getPendingTasks(leaveId: number): Observable<RestResponse> {
        let url = `${API.Actuaciones.getPendingTasks}`;
        url = url.replace('{leaveId}', leaveId.toString());
        return this.apiService.get(url);
    }

    public UpdateActuationEstado(
        actuationId: number,
        Coordinador: string
    ): Observable<RestResponse> {
        let url = `${API.Actuaciones.UpdateActuationEstado}`;
        url = url
            .replace('{ActuationId}', actuationId.toString())
            .replace('{Coordinador}', Coordinador);
        return this.apiService.put(url);
    }

    public GetActuationText(actuationId: number): Observable<RestResponse> {
        let url = `${API.Actuaciones.getActuationText}`;
        url = url.replace('{ActuationId}', String(actuationId));
        return this.apiService.get(url);
    }

    public UpdateActuationText(
        actuationId: number,
        actionData: any
    ): Observable<RestResponse> {
        let url = `${API.Actuaciones.updateActuationText}`;
        url = url.replace('{ActuationId}', String(actuationId));
        return this.apiService.put(url, actionData);
    }

    public DeleteActuation(actuationId: number): Observable<RestResponse> {
        let url = `${API.Actuaciones.deleteActuation}`;
        url = url.replace('{ActuationId}', String(actuationId));
        return this.apiService.delete(url);
    }

    public getMedicos(): Observable<GenericRestResponse<CitationsMedico[]>> {
        let url = API.Actuaciones.getMedicos;
        return this.apiService.get(url);
    }

    public updateActuation(
        actuationId: number,
        actuation: UpdateActuationModel
    ) {
        const url = (API.Actuaciones.updateActuation as string).replace(
            '{actuationId}',
            actuationId.toString()
        );
        return this.apiService.put(url, actuation);
    }

    /**
     * Justify absence (Marcar asuencia justificada)
     */
    public justifyAbsence(actuationId: number, documentBase64: string) {
        const url = (API.Actuaciones.justifyAbsence as string).replace(
            '{actuationId}',
            actuationId.toString()
        );
        return this.apiService.put(url, { DocumentBase64: documentBase64 });
    }

    public undoJustifyAbsence(actuationId: number) {
        const url = (API.Actuaciones.undoJustifyAbsence as string).replace(
            '{actuationId}',
            actuationId.toString()
        );
        return this.apiService.put(url);
    }

    /**
     * Get actuation
     */
    public getActuation(id: number) {
        const url = (API.Actuaciones.getActuation as string).replace(
            '{id}',
            id.toString()
        );
        return this.apiService.get(url);
    }

    /**
     * Update a solicitud
     */
    public updateSolicitud(
        solicitudId: number,
        solicitud: Actuation
    ): Observable<GenericRestResponse<Actuation>> {
        const url = (API.Actuaciones.updateSolicitud as string).replace(
            '{id}',
            solicitudId.toString()
        );
        return this.apiService.put(url, solicitud);
    }

    /**
     * Get actions types list
     */
    public getActionsTypes(): Observable<
        GenericRestResponse<DropDownOption<number>[]>
    > {
        const url = API.Actuaciones.actuationTypesCommonEndpoint;
        return this.apiService.get(url);
    }

    /**
     * Change action type
     */
    public changeActionType(id: number, action: Actuation) {
        const url = `${API.Actuaciones.actuationTypesCommonEndpoint}/${id}`;
        return this.apiService.put(url, action);
    }

    /**
     * Add computed field to actuations
     */
    private addComputedFields(
        actuations: any[],
        featureAdders: ActuationFeatureAdder[]
    ) {
        actuations.forEach((actuation) => {
            featureAdders.forEach((adder) => {
                adder(actuation);
            });
        });
    }

    /**
     * Compter registor hint display value. Add registroHint to the actuation
     */
    private computeRegistroHint(actuation: any) {
        let hintText = '';

        if (actuation.usuario) hintText += actuation.usuario;

        if (actuation.fechaRegistro) {
            if (hintText) hintText += ' - ';

            const fRegistro = moment(actuation.fechaRegistro);
            hintText += fRegistro.format('DD/MM/YYYY HH:mm');
        }

        if (hintText) hintText = 'Registro: ' + hintText;

        actuation.registroHint = hintText;
    }

    //#region CITATIONS

    public createPedirCita(
        pedirCitation: PedirCitation
    ): Observable<GenericRestResponse<null>> {
        let url = API.Actuaciones.createPedirCita;
        return this.apiService.post(url, pedirCitation);
    }

    public createFormalCita(
        citation: CitationFormal
    ): Observable<GenericRestResponse<null>> {
        let url = API.Actuaciones.createFormalCitation;
        return this.apiService.post(url, citation);
    }

    public createAknowledgementReceipt(
        aknowledgementReceipt: AknowledgementReceipt
    ) {
        const url = API.Actuaciones.createAknowledgementReceipt as string;
        return this.apiService.post(url, aknowledgementReceipt);
    }

    /**
     * Get date time for citations
     */
    public getCitationDefaultValues(
        leaveId: number
    ): Observable<GenericRestResponse<CitacionDefaultValues>> {
        const url = (
            API.Actuaciones.getCitationDefaultValues as string
        ).replace('{leaveId}', leaveId.toString());
        return this.apiService.get(url);
    }

    //#endregion

    //#region ACTION CUT (MOVE)

    /**
     * Save action data for moving
     */
    public cutActions(actionCutData: ActionCutData) {
        const data: any = { ...actionCutData };

        if (data.fecha)
            data.fecha = this.dateTimeUtils.convertMomentForBackend(data.fecha);
        if (data.hasta)
            data.hasta = this.dateTimeUtils.convertMomentForBackend(data.hasta);

        // save action cut data in local storage
        localStorage.setItem(KEY_ACTION_CUT_DATA, JSON.stringify(data));
    }

    /**
     * Check if there is action cut data in local storage
     */
    public areActionCutDataAvailable(): boolean {
        return localStorage.getItem(KEY_ACTION_CUT_DATA) != null;
    }

    /**
     * Paste actions from local storage in the leave
     */
    public pasteActions(
        leaveId: number
    ): Observable<GenericRestResponse<null>> {
        const actionCutData: ActionCutData = JSON.parse(
            localStorage.getItem(KEY_ACTION_CUT_DATA)
        );
        const url = (API.Actuaciones.pasteActions as string).replace(
            '{leaveId}',
            leaveId.toString()
        );
        return this.apiService.post(url, actionCutData);
    }

    /**
     * Clear action cut data
     */
    public clearActionCutData() {
        localStorage.removeItem(KEY_ACTION_CUT_DATA);
    }

    //#endregion
}
